import * as ActionTypes from '../actions/types/DashboardActionTypesV2';

const initialState = {
  loading: false,
  snapshot_view: {},
  status_center_view: {},
  progress_view: {},
};

const dashboardReducerV2 = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_DASHBOARD_V2: {
      return Object.assign({}, state, { loading: true });
    }
    case ActionTypes.RECEIVE_DASHBOARD_V2: {
      return Object.assign(
        {},
        state,
        action.payload,
        { loading: false }
      );
    }
    default: return state;
  }
};

export default dashboardReducerV2;



// WEBPACK FOOTER //
// ./src/reducers/dashboardV2.js